module.exports = __webpack_public_path__ + "static/media/Z.21280798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/Z.jpg
// module id = 94
// module chunks = 0